module.exports = __webpack_public_path__ + "img/orderProcess.7bc92f4d.png";